import axios from "../axiosInstance";

const supplierAPI = {
  search: (params) => axios.get("/suppliers/search", { params }),

  getDetails: (params) => axios.get("suppliers/", {params}),

  addDetails: (payload) => axios.post("suppliers/", payload),

  updateDetails: (id, payload) => axios.put(`suppliers/${id}`, payload),

  getSingleDetails: (id) => axios.get(`suppliers/${id}`),

  deleteItem: (id) => axios.delete(`suppliers/${id}`),

};

export default supplierAPI;
